import { render, staticRenderFns } from "./SuperAdminAccount.vue?vue&type=template&id=24bce61a&"
import script from "./SuperAdminAccount.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports